import { Modal } from "react-bootstrap";
import React, { useState } from "react";
import SearchBoxModal from "../component/SearchBoxModal";

export default function ModalThemLoaiToTrinhKhac({ onChange, onClose }) {
    const [show, setShow] = useState(true);
    const [listProgress, setListProgress] = useState([]);
    const [tempUser, setTempUser] = useState({}); // tạm lưu user đang chọn theo progress id
    const [resetKey, setResetKey] = useState(0);
    // 🧩 Thêm tiến trình mới
    const handleAddProgress = () => {
        const newProgress = {
            id: Date.now(),
            wf_type: null,
            departments: "[]",
            title: `Tiến trình ${listProgress.length + 1}`,
            position: listProgress.length + 1,
            status: 1,
            author_id: null,
            datecreate: Date.now(),
            datemodified: Date.now(),
            list_progress: []
        };
        setListProgress(prev => [...prev, newProgress]);
    };

    // 🧩 Xóa tiến trình
    const handleRemoveProgress = (id) => {
        setListProgress(prev =>
            prev
                .filter(item => item.id !== id)
                .map((p, i) => ({
                    ...p,
                    position: i + 1, // chỉ cập nhật lại thứ tự
                }))
        );
    };

    // 🧩 Cập nhật tiêu đề tiến trình
    const handleTitleChange = (id, newTitle) => {
        setListProgress(prev =>
            prev.map(p => (p.id === id ? { ...p, title: newTitle } : p))
        );
    };

    // 🧩 Xóa người tham gia trong tiến trình
    const handleRemoveMember = (progressId, userId) => {
        setListProgress(prev =>
            prev.map(p => {
                if (p.id === progressId) {
                    return {
                        ...p,
                        list_progress: p.list_progress.filter(u => u.user_id !== userId)
                    };
                }
                return p;
            })
        );
    };

    // 🧩 Thêm người vào tiến trình
    const handleAddMember = (progressId) => {
        const user = tempUser[progressId];
        if (!user?.user_id) return;

        setListProgress(prev =>
            prev.map(p => {
                if (p.id === progressId) {
                    // tránh trùng user
                    const exists = p.list_progress.some(u => u.user_id === user.user_id);
                    if (exists) return p;

                    return {
                        ...p,
                        list_progress: [
                            ...p.list_progress,
                            {
                                user_id: user.user_id,
                                user_label: user.user_label,
                                kyphu: 0,
                                list_kyphu: []
                            }
                        ]
                    };
                }
                return p;
            })
        );

        // reset user tạm sau khi thêm
        setTempUser(prev => ({
            ...prev,
            [progressId]: { user_id: null, user_label: "" }
        }));
        setResetKey(prev => prev + 1);
    };

    const handleClose = () => {
        setShow(false);
        if (onClose) onClose();
    };

    const extractFullname = (label = "") => {
        if (!label) return "";

        // Cắt trước dấu "-" hoặc "(" nếu có
        let name = label.split("-")[0].split("(")[0].trim();

        // Nếu vẫn còn ký tự không mong muốn ở cuối, loại bỏ
        name = name.replace(/\s+$/, "");

        return name;
    }

    return (
        <Modal show={show} onHide={handleClose} animation={true} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Thêm loại tờ trình thủ công</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex flex-row flex-wrap align-items-start gap-3">
                    {/* Các tiến trình */}
                    {listProgress.map((progress, index) => (
                        <div
                            key={progress.id}
                            className="border rounded shadow-sm p-3"
                            style={{ width: "260px", minHeight: "230px", position: "relative" }}
                        >
                            <div className="border-bottom pb-2 mb-2 d-flex justify-content-between align-items-center">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={progress.title}
                                    onChange={(e) => handleTitleChange(progress.id, e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    title="Xóa tiến trình"
                                    onClick={() => handleRemoveProgress(progress.id)}
                                >
                                    <i className="fas fa-trash"></i>
                                </button>
                            </div>

                            {/* Danh sách người */}
                            <div className="mb-2">
                                {progress.list_progress.length > 0 ? (
                                    <ul className="list-unstyled mb-2">
                                        {progress.list_progress.map((mem) => (
                                            <li
                                                key={mem.user_id}
                                                className="small border-bottom py-1 d-flex justify-content-between align-items-center"
                                            >
                                                <span>{mem.user_label}</span>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-link text-danger p-0"
                                                    onClick={() =>
                                                        handleRemoveMember(progress.id, mem.user_id)
                                                    }
                                                >
                                                    <i className="fas fa-times"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-muted small mb-2">Chưa có người tham gia</div>
                                )}
                            </div>

                            {/* Chọn nhân sự */}
                            <div className="w-100">
                                <SearchBoxModal
                                    apiname={"users"}
                                    placeholder="Chọn nhân sự"
                                    colvalue={"id"}
                                    colname={"fullname"}
                                    name={`member_${progress.id}`}
                                    value={tempUser[progress.id]?.user_label || ""}  // 👈 điều khiển giá trị
                                    defaultValue={""}
                                    resetKey={resetKey}
                                    onChange={(id) =>
                                        setTempUser(prev => ({
                                            ...prev,
                                            [progress.id]: {
                                                ...(prev[progress.id] || {}),
                                                user_id: id
                                            }
                                        }))
                                    }
                                    onLabel={(label) =>
                                        setTempUser(prev => ({
                                            ...prev,
                                            [progress.id]: {
                                                ...(prev[progress.id] || {}),
                                                user_label: extractFullname(label)
                                            }
                                        }))
                                    }
                                />
                                <button
                                    className="btn btn-sm btn-primary mt-2 w-100"
                                    onClick={() => handleAddMember(progress.id)}
                                >
                                    <i className="fas fa-user-plus"></i> Thêm người
                                </button>
                            </div>
                        </div>
                    ))}

                    {/* Ô thêm tiến trình */}
                    <div
                        onClick={handleAddProgress}
                        className="border rounded shadow-sm p-3 d-flex flex-column align-items-center justify-content-center text-center"
                        style={{
                            width: "260px",
                            minHeight: "180px",
                            cursor: "pointer",
                            background: "#f8f9fa",
                            borderStyle: "dashed"
                        }}
                    >
                        <i className="fas fa-plus-circle fa-2x text-primary mb-2"></i>
                        <div>Thêm tiến trình</div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose}>
                    Đóng
                </button>
                <button
                    className="btn btn-success"
                    onClick={() => {
                        if (onChange) onChange(listProgress);
                        handleClose();
                    }}
                >
                    Lưu lại
                </button>
            </Modal.Footer>
        </Modal>
    );
}
